/**
 * Play Store Readiness is a Nexora Systems internal tool hosted in CrewPilot.
 * It is not a customer-facing CrewPilot feature.
 *
 * Authority is the *active* organization on the actor (organization_members),
 * compared to the canonical Nexora operations organization id. Privileged
 * roles in other organizations do not grant access.
 */

import { isGuestActor } from "./guestMode";
import { NEXORA_OPERATIONS_ORGANIZATION_ID } from "./nexoraOpsAccess";

export const PLAY_STORE_READINESS_SCREEN = "play_store_readiness";
export const PLAY_STORE_READINESS_HASH = "play-store-readiness";

export function isNexoraOperationsActiveOrganization(actor) {
  return (
    Boolean(actor?.organization_id) &&
    actor.organization_id === NEXORA_OPERATIONS_ORGANIZATION_ID
  );
}

/**
 * UI + route gate. Active org must be the canonical Nexora Systems org.
 * Membership in Nexora while another org is active is not enough.
 */
export function actorCanAccessPlayStoreReadiness(actor) {
  if (!actor || isGuestActor(actor)) {
    return false;
  }
  return isNexoraOperationsActiveOrganization(actor);
}

function normalizeHash(hash) {
  return String(hash || "")
    .replace(/^#\/?/, "")
    .split("?")[0]
    .trim();
}

export function isPlayStoreReadinessRoute(location) {
  const loc =
    location || (typeof window !== "undefined" ? window.location : null);
  if (!loc) {
    return false;
  }
  if (normalizeHash(loc.hash) === PLAY_STORE_READINESS_HASH) {
    return true;
  }
  try {
    const search = loc.search || "";
    return (
      new URLSearchParams(search).get("screen") === PLAY_STORE_READINESS_SCREEN
    );
  } catch {
    return false;
  }
}

export function setPlayStoreReadinessRoute(active, location) {
  if (typeof window === "undefined") {
    return;
  }
  const loc = location || window.location;
  const currentHash = normalizeHash(loc.hash);
  if (active) {
    if (currentHash === PLAY_STORE_READINESS_HASH) {
      return;
    }
    const url = `${loc.pathname}${loc.search}#${PLAY_STORE_READINESS_HASH}`;
    window.history.replaceState(null, "", url);
    return;
  }
  if (currentHash !== PLAY_STORE_READINESS_HASH) {
    return;
  }
  window.history.replaceState(null, "", `${loc.pathname}${loc.search}`);
}
